import { DocumentViewerModalV2 } from '@dealstack/frontend/shared/components/DocumentViewerV2/DocumentViewerModalV2';
import { useDownloadedFileBlob } from '@dealstack/frontend/shared/modules/document/file/hooks/useDownloadedFileBlob';

interface Props {
	onClose: () => void;
	fileId: string;
	fileName: string;
	dealId: string;
}

export const ReviewContractDocumentModal = ({ onClose, fileId, fileName, dealId }: Props) => {
	const { data: file, isLoading } = useDownloadedFileBlob({
		fileId,
		dealId,
	});

	return (
		<DocumentViewerModalV2
			opened
			file={file?.blob}
			fileName={fileName}
			fileExtension={file?.fileExtension}
			isLoading={isLoading}
			onClose={onClose}
		/>
	);
};
